export default __webpack_public_path__ + "static/media/logo-footer.7b436c56.jpg";